export const registrationPlateRegex = /^[\p{Letter}|\p{Number}]{1,10}$/gu;
